import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { PostHogService } from './posthog.service';

@Injectable()
export class TelemetryErrorHandler implements ErrorHandler {
  constructor(private readonly injector: Injector) {}

  handleError(error: any): void {
    try {
      // Retrieve service lazily to avoid circular DI during Angular boot
      const posthogService = this.injector.get(PostHogService);
      if (posthogService) {
        posthogService.captureError(error, { error_type: 'AngularUnhandledException' });
      }
    } catch {
      // Telemetry error must never block console reporting
    } finally {
      // Also output to console for local developer debugging
      console.error('Unhandled Application Exception:', error);
    }
  }
}
